import MainLayout from "../layouts/MainLayout";
import EmptyLayout from "../layouts/EmptyLayout";

import general from "./general";
import user from "./user";
import reservations from "./reservations";
import customers from "./customers";
import invoices from "./invoices";
import billingprofiles from "./billingprofiles";
import payment from "./payment";
import coupons from "./coupons";
import settins from "./settings";
import rewards from "./rewards";

const routes =  [{
    layout: MainLayout,
    routes: [
        ...general,
        ...reservations,
        ...customers,
        ...invoices,
        ...coupons,
        ...rewards,
        ...billingprofiles,
        ...payment,
        ...settins
    ].map(route => ({
        ...route,
        private: route.private ?? true
    }))
},{
    layout: EmptyLayout,
    routes: [
        ...user,
    ]
}]

export default routes;